module.exports = __webpack_public_path__ + "fonts/work-sans-v4-latin-ext-100.f3861e80.woff";